import { LocationImport } from 'planning-portal-library/src/lib/core/domain/models/location-import.model';
import { Mapper } from '../../../../../core/base';
import { LocationImportWebEntity } from './location-import.web-entity';
import {
  CapacityWebEntity,
  ClosedDayWebEntity,
  OpeningHourWebEntity,
  PrivateLocatioDetailsWebEntity,
  ProductActivityHourWebEntity,
  ProductDetailsWebEntity,
  SelectedProductActivityWebEntity,
  SelectedProductWebEntity,
  ServiceHourWebEntity,
} from './private-location.web-entity.ts';
import {
  Capacity,
  ClosedDay,
  OpeningHour,
  PrivateLocatioDetails,
  ProductActivityHour,
  ProductDetails,
  SelectedProduct,
  SelectedProductActivity,
  ServiceHour,
} from 'planning-portal-library/src/lib/core/domain';
import { KeyValueDataRequest } from 'planning-portal-library/src/lib/core/domain/models/key-value-data-request';
import { KeyValueDataWebEntity } from './private-location.web-entity.ts/Key-value-data.web-entity';

export class PrivateLocationDetailMapper extends Mapper<
  PrivateLocatioDetailsWebEntity,
  PrivateLocatioDetails
> {
  mapFrom(param: PrivateLocatioDetailsWebEntity): PrivateLocatioDetails {
    return {
      openingHours: param.openingHours!.map(
        (opningHours: OpeningHour): OpeningHourWebEntity => ({
          day: opningHours.day,
          fromTime: opningHours.fromTime,
          toTime: opningHours.toTime,
          isEnabled: opningHours.isEnabled,
        })
      ),
      closedDays: param.closedDays!.map(
        (closedDays: ClosedDay): ClosedDayWebEntity => ({
          title: closedDays.title,
          fromDate: closedDays.fromDate,
          toDate: closedDays.toDate,
        })
      ),
      selectedProducts: param.selectedProducts!.map(
        (selectedProduct: SelectedProduct): SelectedProductWebEntity => ({
          productId: selectedProduct.productId,
          selectedProductActivities:
            selectedProduct.selectedProductActivities.map(
              (
                selectedProductActivities: SelectedProductActivity
              ): SelectedProductActivityWebEntity => ({
                activityName: selectedProductActivities.activityName,
                activityId: selectedProductActivities.activityId,
              })
            ),
          serviceHours: selectedProduct.serviceHours.map(
            (serviceHour: ServiceHour): ServiceHourWebEntity => ({
              forProductActivity: serviceHour.forProductActivity,
              day: serviceHour.day,
              productActivityHours: serviceHour.productActivityHours.map(
                (
                  productActivityHour: ProductActivityHour
                ): ProductActivityHourWebEntity => ({
                  productActivityId: productActivityHour.productActivityId,
                  fromTime: productActivityHour.fromTime,
                  toTime: productActivityHour.toTime,
                  stopTime: productActivityHour.stopTime,
                  isForAllProducts: productActivityHour.isForAllProducts,
                  service: productActivityHour.service,
                  serviceTime: productActivityHour.stopTime,
                })
              ),
              capacities: serviceHour.capacities.map(
                (capacity: Capacity): CapacityWebEntity => ({
                  productActivityId: capacity.productActivityId,
                  capacityTypeId: capacity.capacityTypeId,
                  capacity: capacity.capacity,
                })
              ),
              isEnabled: serviceHour.isEnabled,
            })
          ),
        })
      ),
      products: param.products!.map(
        (product: ProductDetails): ProductDetailsWebEntity => ({
          productId: product.productId,
          productName: product.productName,
          daoLocationKey: product.daoLocationKey,
          productKeyMapping: product.productKeyMapping,
          keyValueData: product.keyValueData,
          segment: product.segment,
          shouldVisitIfNoService: product.shouldVisitIfNoService,
        })
      ),
      keyValueData: param.keyValueData!.map(
        (keyValue: KeyValueDataWebEntity): KeyValueDataRequest => ({
          Key: keyValue.key,
          Name: keyValue.name,
        })
      ),
    };
  }

  mapTo(param: PrivateLocatioDetails): PrivateLocatioDetailsWebEntity {
    return {
      openingHours: param.openingHours?.map(
        (opningHours: OpeningHourWebEntity): OpeningHour => ({
          day: opningHours.day,
          fromTime: opningHours.fromTime,
          toTime: opningHours.toTime,
          isEnabled: opningHours.isEnabled,
        })
      ),
      closedDays: param.closedDays?.map(
        (closedDays: ClosedDayWebEntity): ClosedDay => ({
          title: closedDays.title,
          fromDate: closedDays.fromDate,
          toDate: closedDays.toDate,
        })
      ),
      selectedProducts: param.selectedProducts?.map(
        (selectedProduct: SelectedProductWebEntity): SelectedProduct => ({
          productId: selectedProduct.productId,
          selectedProductActivities:
            selectedProduct.selectedProductActivities.map(
              (
                selectedProductActivities: SelectedProductActivityWebEntity
              ): SelectedProductActivity => ({
                activityName: selectedProductActivities.activityName,
                activityId: selectedProductActivities.activityId,
              })
            ),
          serviceHours: selectedProduct.serviceHours.map(
            (serviceHour: ServiceHourWebEntity): ServiceHour => ({
              forProductActivity: serviceHour.forProductActivity,
              day: serviceHour.day,
              productActivityHours: serviceHour.productActivityHours.map(
                (
                  productActivityHour: ProductActivityHourWebEntity
                ): ProductActivityHour => ({
                  productActivityId: productActivityHour.productActivityId,
                  fromTime: productActivityHour.fromTime,
                  toTime: productActivityHour.toTime,
                  stopTime: productActivityHour.stopTime,
                  isForAllProducts: productActivityHour.isForAllProducts,
                  service: productActivityHour.service,
                  serviceTime: productActivityHour.serviceTime,
                })
              ),
              capacities: serviceHour.capacities.map(
                (capacity: CapacityWebEntity): Capacity => ({
                  productActivityId: capacity.productActivityId,
                  capacityTypeId: capacity.capacityTypeId,
                  capacity: capacity.capacity,
                })
              ),
              isEnabled: serviceHour.isEnabled,
            })
          ),
        })
      ),
      products: param.products?.map(
        (product: ProductDetailsWebEntity): ProductDetails => ({
          productId: product.productId,
          productName: product.productName,
          daoLocationKey: product.daoLocationKey,
          productKeyMapping: product.productKeyMapping,
          keyValueData: product.keyValueData,
          segment: product.segment,
          shouldVisitIfNoService: product.shouldVisitIfNoService,
        })
      ),
    };
  }
}
